/*
==========================================
Custom JS for Collection page
==========================================
*/

// レイアウト切り替え表示
const changeLayoutMode = (_this)=>{
  const layout_type = _this.dataset.layout_type,
  device = _this.dataset.device;

  document.querySelector(`.c-change-layout__wrapper--${device} .c-change-layout.is-active`).classList.remove('is-active');
  _this.classList.add('is-active');

  const grid_elem = document.querySelector('.boost-pfs-filter-products');
  const grid_classlist = Array.from(grid_elem.classList);
  const grid_layout_class = grid_classlist.find(className => className.includes(`-col-${device}`));

  grid_elem.classList.remove(grid_layout_class);
  grid_elem.classList.add(`grid--${layout_type}-col-${device}`);
}

/*
==========================================
Custom JS for Collection page
検索アプリに対しての処理
==========================================
*/

// -- クイックカートイン --
const accessAddToCart = (_item_id) => {
  const btn_elem = document.querySelector(`li[data-id="${_item_id}"] .boost-pfs-addtocart-btn`);
  if(btn_elem){
    btn_elem.click();
  }
}

// -- クイックビュー --
// メソッド：クイックビュー内の数量変更
const changeQtyInQuickView = (e) => {
  document.querySelector('#boost-pfs-quickview-cart-quantity').value = e.target.value;
}
// メソッド：クイックビュー内のお気に入りボタン
const callWishlistInQuickview = (e,_item_id) => {
  const targtItemFavo = document.querySelector(`li[data-id="${_item_id}"] .swym-button`);
  if(targtItemFavo){
    document.querySelector('.boost-pfs-quickview-close').click();
    targtItemFavo.click();
  }
}
// メソッド：クイックビュー内のカート追加ボタn
const callAddToCartInQuickview = (e) => {
  document.querySelector('#boost-pfs-quickview-cart-form button[type="submit"]').click();
}
const accessQuickView = (_item_id,_item_variant_id) => {
  const btn_elem = document.querySelector(`li[data-id="${_item_id}"] .boost-pfs-quickview-btn`);
  if(btn_elem){
    btn_elem.click();

    // クイックビュー 数量セレクター・在庫表示書き換え
    const intervalId = setInterval(()=>{
      const quickview_form = document.getElementById('boost-pfs-quickview-cart-form');
      if(quickview_form && quickview_form.querySelector(`[data-variant-id="${_item_variant_id}"]`)){
        //ドキュメントが読み込まれば処理開始
        let renderHTML = "";
        // すでにセクション生成済みであれば初期化
        if(document.querySelector('.boost-pfs-quickview-wrapper .c-product-section')){
          document.querySelector('.boost-pfs-quickview-wrapper .c-product-section').remove();
        }

        // 商品情報を取得
        const itemElem = document.querySelector(`li[data-id="${_item_id}"]`);
        const itemTitle = itemElem.getAttribute("data-item_title"),
          itemVendor = itemElem.getAttribute("data-item_vendor"),
          itemUrl = itemElem.getAttribute("data-item_url"),
          itemTags = itemElem.getAttribute("data-item_tags"),
          itemInventory = Number(itemElem.getAttribute("data-item_inventory")),
          itemAvailable = itemElem.getAttribute("data-item_available"),
          itemBISHidden = itemElem.getAttribute("data-item_BIS_hidden"),
          itemAddToCartHidden = itemElem.getAttribute("data-item_addtocart_hidden"),
          itemReferencePrice = itemElem.getAttribute("data-item_reference_price") ? Number(itemElem.getAttribute("data-item_reference_price")) : 0;

        // 商品情報 ヘッダーのHTMLを生成
        const itemInfoHTML = `
        <div class="product__info-container">
          <div class="product__title-wrapper">
            <p class="product__text subtitle tags__underline">
              <a href="/collections/${itemVendor}" class="underlined-link c-txt c-color__text">${itemVendor}</a>
            </p>
            <div class="product__title">
              <a href="${itemUrl}"><h1 class="c-color__text ">${itemTitle}</h1></a>
            </div>
          </div>
        </div>
        `;

        // 商品情報 金額
        let itemPriceHTML = "";
        if(itemReferencePrice > 0){
          itemPriceHTML = `
            <div class="c-txt c-color__text" style="font-weight:300; margin-bottom:0.9rem;">参考価格</div>
            <div class="price price--large">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">通常価格</span>
                  <span class="price-item price-item--regular">${Utils.formatMoney(itemReferencePrice)}</span><span class="c-txt--small">（税込）</span>
                </div>
              </div>
            </div>
          `;
        }else{
          itemPriceHTML = itemElem.querySelector('.card-information .price').outerHTML;
        }

        // 商品情報 タグ
        let itemTagsHTML = "";
        if(itemTags.length > 0){
          let tag_list = itemTags.split(',');
          tag_list.forEach(tag => {
            itemTagsHTML += `<span class="tag__element c-txt">${tag}</span>`;
          })
        }
        if(itemTagsHTML.length > 0){
          itemTagsHTML = `<div class="tags_wrapper">${itemTagsHTML}</div>`;
        }

        // 商品情報 説明
        const itemDescriptionHTML = `<div class="product__description rte c-color__text">
          ${quickview_form.parentNode.querySelector('.boost-pfs-quickview-description').textContent}
        </div>`;

        // 在庫表示
        // 数量セレクター
        let createSelector = `<select onchange="changeQtyInQuickView(event)" class="select__select" ${itemInventory === 0 ? `hidden` : ""}>`;
        for (let i = 1; i <= itemInventory; i++){
          createSelector += `<option value="${i}">${i}</option>`;
        }
        createSelector += `</select>`;
        const favoAddedFlg = itemElem.querySelector('.swym-button.swym-added') ? true : false;

        const itemQuantityHTML = `
        <div class="product-form__input product-form__quantity">
          <div class="c-product-form__quantity-wrapper${ itemInventory > 0 ? "" : " is-hidden-selector" }">
            ${itemTags.indexOf("受注生産") > -1 ? "" : `<div class="c-product-form__inventory c-txt c-color__text"> 在庫数 /${itemInventory}</div>`}
            <quantity-input class="quantity">
              <div class="product-form__input product-form__input--dropdown">
                <div class="select">
                  ${createSelector}
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                  </svg>
                </div>
              </div>
            </quantity-input>
          </div>
          <button type="button" class="c-button c-button__favorite${ favoAddedFlg === true ? " swym-added" : ""}" onclick="callWishlistInQuickview(event,'${_item_id}')">
            <svg class="c-icon c-icon__heart" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1776 2.38522C12.7945 2.12961 13.4557 1.99805 14.1235 1.99805C14.7912 1.99805 15.4524 2.12961 16.0693 2.38522C16.6861 2.6408 17.2466 3.01539 17.7186 3.4876C18.1908 3.95963 18.5656 4.52022 18.8211 5.13704C19.0768 5.75394 19.2083 6.41515 19.2083 7.0829C19.2083 7.75066 19.0768 8.41187 18.8211 9.02876C18.5655 9.64565 18.1909 10.2061 17.7186 10.6782L9.99847 18.3983L2.27825 10.6781C1.32474 9.72461 0.789062 8.43137 0.789062 7.0829C0.789062 5.73443 1.32474 4.44119 2.27825 3.48768C3.23176 2.53417 4.525 1.99849 5.87347 1.99849C7.22194 1.99849 8.51518 2.53417 9.46869 3.48768L9.99847 4.01746L10.5282 3.48776C10.5281 3.48779 10.5282 3.48774 10.5282 3.48776C11.0002 3.01552 11.5608 2.64082 12.1776 2.38522ZM14.1235 2.99805C13.5871 2.99805 13.0559 3.10373 12.5604 3.30906C12.0649 3.51438 11.6146 3.81533 11.2354 4.19471L9.99847 5.43167L8.76158 4.19479C7.99561 3.42881 6.95672 2.99849 5.87347 2.99849C4.79022 2.99849 3.75133 3.42881 2.98536 4.19479C2.21938 4.96076 1.78906 5.99965 1.78906 7.0829C1.78906 8.16615 2.21938 9.20504 2.98536 9.97102L9.99847 16.9841L17.0116 9.97102C17.391 9.59182 17.692 9.14151 17.8973 8.64597C18.1026 8.15043 18.2083 7.61929 18.2083 7.0829C18.2083 6.54651 18.1026 6.01537 17.8973 5.51983C17.692 5.0243 17.391 4.57407 17.0117 4.19487C16.6325 3.8155 16.1821 3.51438 15.6865 3.30906C15.191 3.10373 14.6599 2.99805 14.1235 2.99805Z" fill="#1A1A1A"></path>
            </svg>
            <span class="c-button__favorite-text--not-yet-add c-txt"">お気に入り</span>
            <span class="c-button__favorite-text--added c-txt"">追加済み</span>
          </button>
        </div>
        `;

        const productFormHTML = `
        <div class="product-form__buttons">
          <button type="button" onclick="callAddToCartInQuickview(event)" class="product-form__submit button button--full-width product__button button--primary ${ itemAvailable === "false" ? "is-disbled" : ""}" ${ itemAvailable === "false" ? "disbled" : ""}>
            <svg class="c-icon c-icon__cart" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5013 17.167C7.31721 17.167 7.16797 17.3162 7.16797 17.5003C7.16797 17.6844 7.31721 17.8337 7.5013 17.8337C7.6854 17.8337 7.83464 17.6844 7.83464 17.5003C7.83464 17.3162 7.6854 17.167 7.5013 17.167ZM6.16797 17.5003C6.16797 16.7639 6.76492 16.167 7.5013 16.167C8.23768 16.167 8.83464 16.7639 8.83464 17.5003C8.83464 18.2367 8.23768 18.8337 7.5013 18.8337C6.76492 18.8337 6.16797 18.2367 6.16797 17.5003Z" fill="#1A1A1A"></path>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6654 17.167C16.4813 17.167 16.332 17.3162 16.332 17.5003C16.332 17.6844 16.4813 17.8337 16.6654 17.8337C16.8495 17.8337 16.9987 17.6844 16.9987 17.5003C16.9987 17.3162 16.8495 17.167 16.6654 17.167ZM15.332 17.5003C15.332 16.7639 15.929 16.167 16.6654 16.167C17.4017 16.167 17.9987 16.7639 17.9987 17.5003C17.9987 18.2367 17.4017 18.8337 16.6654 18.8337C15.929 18.8337 15.332 18.2367 15.332 17.5003Z" fill="#1A1A1A"></path>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.332031 0.833008C0.332031 0.556865 0.555889 0.333008 0.832031 0.333008H4.16536C4.40368 0.333008 4.60887 0.5012 4.65564 0.734879L5.40916 4.49967H19.1654C19.3144 4.49967 19.4556 4.56614 19.5506 4.68095C19.6456 4.79577 19.6844 4.94696 19.6565 5.09334L18.3232 12.085L18.3224 12.0887C18.2234 12.5875 17.9521 13.0355 17.5559 13.3544C17.1612 13.6722 16.6675 13.8415 16.1609 13.833H8.0698C7.56319 13.8415 7.06956 13.6722 6.67479 13.3544C6.27883 13.0357 6.00754 12.5878 5.90839 12.0893C5.90835 12.0891 5.90842 12.0895 5.90839 12.0893L4.51432 5.12418C4.50997 5.10719 4.50648 5.08984 4.50392 5.0722L3.75552 1.33301H0.832031C0.555889 1.33301 0.332031 1.10915 0.332031 0.833008ZM5.60931 5.49967L6.88897 11.8932C6.94232 12.1618 7.08856 12.4037 7.30185 12.5754C7.51514 12.7471 7.78202 12.8383 8.05578 12.8331L8.06536 12.8329L16.1749 12.833C16.4487 12.8383 16.7156 12.7471 16.9289 12.5754C17.1417 12.4041 17.2877 12.1635 17.3413 11.8956C17.3414 11.895 17.3415 11.8945 17.3416 11.8939L18.561 5.49967H5.60931Z" fill="#1A1A1A"></path>
            </svg>  
            <span class="c-txt__subtitle">${ itemAvailable === "false" && itemBISHidden === "true" ? "販売終了" : itemAvailable === "false" ? "入荷待ち" : "カートに入れる"}</span>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>
          <div class="product__view-details">
            <a href="${itemUrl}" class="underlined-link c-underlined-link__large">商品詳細を見る</a>
          </div>
        </div>
        `;


        renderHTML += `<div class="c-product-section" data-item_addtocart_hidden="${itemAddToCartHidden}">${itemInfoHTML + itemPriceHTML + itemTagsHTML + itemDescriptionHTML + itemQuantityHTML + productFormHTML}</div>`;
        quickview_form.parentNode.insertAdjacentHTML('afterbegin', renderHTML);

        clearInterval(intervalId);
      }
    },1000);
  }
}

// -- フィルターツリー --
const accessFilterTree = () =>{
  const btn_elem = document.querySelector(`.boost-pfs-filter-tree-mobile-button button`);
  if(btn_elem){
    btn_elem.click();
  }
}

// ヘッダー カートアイコン(商品一覧のみ)
// アプリ機能画面の場合、カートアイコン押下でクイックインが表示されるため処理を修正
window.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.c-header__icon--cart').forEach(cartIcon => {
    cartIcon.setAttribute("href","javascript:void(0)");
    cartIcon.addEventListener('click',(event)=>{
      event.preventDefault();
      location.href="/cart";
    })
  })
})